import { render, staticRenderFns } from "./DocumentPreview.vue?vue&type=template&id=43144542&"
import script from "./DocumentPreview.vue?vue&type=script&lang=ts&"
export * from "./DocumentPreview.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports